import { Grid } from "@material-ui/core";
import styles from "./Snackbar.module.scss";
import { ReactComponent as SuccessCloud } from "../../../images/icon-success-cloud.svg";
import classNames from "classnames";

export const FinalisedSucessMessage = (props: { onClose: any }) => {

    const handleClose = () => {
        props.onClose();
    };

    return (
        <Grid container className={styles.successBackground}>
            <Grid xs={1} container className={styles.statusIcon}>
                <SuccessCloud></SuccessCloud>
            </Grid>
            <Grid xs={7} container className={styles.content}>
                <div className={styles.font600}>Success!</div>
                <div style={{ marginTop: "-28px" }}>
                    Your changes have been finalised and sent to the pharmacy
                </div>
            </Grid>
            <Grid item container direction="column" xs={4}>
                <Grid item xs container className={classNames(styles.actionContent, styles.linkBorder)}>
                    <div>
                        <a onClick={handleClose} className={styles.link}> Stay on this screen </a>
                    </div>
                </Grid>
                <Grid item xs container className={styles.actionContent}>
                    <div>
                        <a href="/residents" className={styles.link}> Return to list of all residents </a>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
}